import {NgxFilterBaseComponent} from "../ngx-filter-base-component";

export abstract class NgxTextBoxFilter extends NgxFilterBaseComponent {

}
